module.exports = __webpack_public_path__ + "img/frown.aa7fc941.svg";